<template>
  <div>
    <page-head
      :title="title"
      :btn-list="!isEdit && (isArea || isStreet) ? btnList : btnList1"
      :show-back="true"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="老人姓名">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.name"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.name }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="老人身份证号">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.idCardNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.idCardNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="老人/家属联系电话">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.phoneNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.phoneNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="所属区域">
                <template v-if="isEdit">
                  <Cascader
                    v-model="comList"
                    :data="communityList"
                    placeholder="请选择"
                    clearable
                    @on-change="communityChange"
                    change-on-select
                  ></Cascader>
                </template>
                <template v-else>
                  <div class="detail">
                    {{ shutAreaname(info.communityPathname) }}
                  </div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="老人家庭地址">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.address"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.address }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="老人类型">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.personnelType"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.personnelType }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="申办人">
                <template v-if="isEdit">
                  <Select v-model="info.applicantMode" style="width: 200px">
                    <Option
                      v-for="item in personList"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </template>
                <template v-else>
                  <div class="detail">
                    {{ info.applicantMode == 1 ? "本人办理" : "家属代办" }}
                  </div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="info.applicantMode != 1">
              <FormItem label="代办人姓名">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.agentName"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.agentName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="info.applicantMode != 1">
              <FormItem label="代办人手机号">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.agentPhoneNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.agentPhoneNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="info.applicantMode != 1">
              <FormItem label="代办人身份证号">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.agentCardNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.agentCardNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="银行户名">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.userName"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.userName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="银行名称">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.bankName"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.bankName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="银行卡号">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.creditCardNumbers"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.creditCardNumbers }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="家属姓名">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.familyName"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.familyName }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="家属联系电话">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.familyPhoneNO"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.familyPhoneNO }}</div>
                </template>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="与老人关系">
                <template v-if="isEdit">
                  <Input type="text" v-model="info.familyRelation"></Input>
                </template>
                <template v-else>
                  <div class="detail">{{ info.familyRelation }}</div>
                </template>
              </FormItem>
            </i-col>
          </row>
          <row :gutter="80">
            <i-col span="24">
              <FormItem label="照片">
                <!-- <img v-if="info.headPicUrl" class="headPicUrl" :src="info.headPicUrl" /> -->
                <template v-if="isEdit">
                  <div class="box">
                    <upl-img-act
                      :imgArr="imgArr"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="100"
                      :imgWidth="100"
                      @saveImg="saveImg"
                      @delPic="delImg"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                      </div>
                    </upl-img-act>

                    <upl-img-act
                      :imgArr="imgArr2"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="100"
                      :imgWidth="100"
                      @saveImg="saveImg2"
                      @delPic="delImg2"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                      </div>
                    </upl-img-act>

                    <upl-img-act
                      :imgArr="imgArr3"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="100"
                      :imgWidth="100"
                      @saveImg="saveImg3"
                      @delPic="delImg3"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                      </div>
                    </upl-img-act>

                    <upl-img-act
                      :imgArr="imgArr4"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="100"
                      :imgWidth="100"
                      @saveImg="saveImg4"
                      @delPic="delImg4"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                      </div>
                    </upl-img-act>
                  </div>
                </template>
                <template v-else>
                  <el-image
                    v-if="info.headPortraitPicture"
                    class="headPicUrl"
                    :preview-src-list="[
                      info.headPortraitPicture,
                      info.originalCardPicture,
                      info.originalHouseholdPicture,
                    ]"
                    :src="info.headPortraitPicture"
                  />
                  <el-image
                    v-if="info.socialCardPicture"
                    class="headPicUrl"
                    :preview-src-list="[
                      info.socialCardPicture,
                      info.socialCardPicture,
                      info.originalHouseholdPicture,
                    ]"
                    :src="info.socialCardPicture"
                  />
                  <el-image
                    v-if="info.originalCardPicture"
                    class="headPicUrl"
                    :preview-src-list="[
                      info.originalCardPicture,
                      info.originalHouseholdPicture,
                      info.headPortraitPicture,
                    ]"
                    :src="info.originalCardPicture"
                  />
                  <el-image
                    v-if="info.originalHouseholdPictureFirst"
                    class="headPicUrl"
                    :preview-src-list="[
                      info.originalHouseholdPictureFirst,
                      info.originalHouseholdPicture,
                      info.headPortraitPicture,
                      info.originalCardPicture,
                    ]"
                    :src="info.originalHouseholdPictureFirst"
                  />
                  <el-image
                    v-if="info.originalHouseholdPicture"
                    class="headPicUrl"
                    :preview-src-list="[
                      info.originalHouseholdPicture,
                      info.headPortraitPicture,
                      info.originalCardPicture,
                    ]"
                    :src="info.originalHouseholdPicture"
                  />
                </template>
              </FormItem>
            </i-col>
          </row>
        </Form>
      </div>
      <div class="table-data">
        <div class="verifyRecord">申请记录</div>
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
        >
          <template slot-scope="{ row, index }" slot="administrationAudit">
            <span
              :class="[parseInt(row.administrationAudit) == 1 ? 'success' : '']"
              >{{
                !row.administrationAudit ||
                parseInt(row.administrationAudit) == 0
                  ? "待审核"
                  : parseInt(row.administrationAudit) == 1
                  ? "审核通过"
                  : "审核未通过"
              }}</span
            >
          </template>
          <!-- <template slot-scope="{ row, index }" slot="streetAudit">
            <span :class="[parseInt(row.streetAudit)==1?'success':'']">{{(!row.streetAudit || parseInt(row.streetAudit)==0)?'待审核':(parseInt(row.streetAudit)==1?'审核通过':'审核未通过')}}</span>
          </template>  -->
          <template slot-scope="{ row, index }" slot="updateTime">
            <span>
              {{
                (!row.administrationAudit ||
                  parseInt(row.administrationAudit) == 0) &&
                (!row.streetAudit || parseInt(row.streetAudit) == 0)
                  ? ""
                  : row.checkTime
              }}</span
            >
          </template>
        </i-table>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import uplImgAct from "../../../components/uplImgAct";
import api from "../../../api/index";
const { handleApply, applyList } = api;
export default {
  name: "applyDetail",
  components: {
    pageHead,
    uplImgAct,
  },
  data() {
    return {
      title: "申请详情",
      imgArr: [],
      imgArr2: [],
      imgArr3: [],
      imgArr4: [],
      imgNumber: 1,
      fixedNumber: [1, 1],
      comList: [], // 回显list
      communityList: [], // 数据源list
      communityId: "", // 选中的commuId
      savedId: "",
      personList: [
        {
          value: 1,
          label: "本人办理",
        },
        {
          value: 2,
          label: "家属代办",
        },
      ],
      btnList: [
        {
          name: "审核未通过",
          type: "artificialRefuse",
        },
        {
          name: "审核通过",
          type: "artificialPass",
        },
        {
          name: "编辑",
          type: "edit",
        },
      ],
      btnList1: [
        {
          name: "编辑",
          type: "edit",
          loading: false,
        },
      ],
      isEdit: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      info: {
        applicantMode: 1,
      },
      tableData: [],
      isTableLoading: false,
      tableHeader: [
        {
          title: "序号",
          type: "index",
          // width: 80,
          // align: "center"
        },
        {
          title: "申请时间",
          key: "createTime",
        },
        {
          title: "审核人",
          key: "checkUserName",
        },
        {
          title: "审核时间",
          slot: "updateTime",
        },
        // {
        //   title: "街道审核状态",
        //   slot: "streetAudit"
        // },
        {
          title: "审核状态",
          slot: "administrationAudit",
        },
      ],
      isArea: true,
      isStreet: false,
    };
  },
  methods: {
    shutAreaname(communityPathname) {
      let result = "";
      if (communityPathname) {
        let newcommunityPathname = communityPathname.slice(
          7,
          communityPathname.length
        );
        result = newcommunityPathname.replace(/\./g, "");
      }
      return result;
    },
    async artificial(result) {
      //审核通过嗯
      try {
        let data = {};
        if (this.isStreet) {
          data.streetAudit = result;
        } else {
          data.administrationAudit = result;
        }
        data.id = +this.$route.query.id;
        let res = await this.$get(this.urlobj.updateAuditStatus, data);
        if (res.isSucceed) {
          this.$Message.success("操作成功");
          this.getDetail();
        } else {
          this.$Message.error("操作失败 " + res.message);
        }
      } finally {
      }
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    communityChange(value) {
      console.log(value);
      let returndata = value[value.length - 1];
      this.communityId = returndata;
      console.log(this.communityId);
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: item.communityId,
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    handleBtn(type) {
      if (type == "artificialPass") {
        this.artificial(1);
      } else if (type == "artificialRefuse") {
        this.artificial(2);
      } else if (type == "edit") {
        if (!this.isEdit) {
          this.isEdit = true;
          console.log("edit");
          this.$set(this.btnList1[0], "name", "保存");
        } else {
          this.saveInfo();
        }
      }
    },
    saveImg(value) {
      this.imgArr = [value];
      this.info.headPortraitPicture = this.imgArr[0].path;
    },
    delImg() {
      this.info.headPortraitPicture = "";
      this.imgArr = [];
    },
    saveImg2(value) {
      this.imgArr2 = [value];
      this.info.originalCardPicture = this.imgArr2[0].path;
    },
    delImg2() {
      this.info.originalCardPicture = "";
      this.imgArr2 = [];
    },
    saveImg3(value) {
      this.imgArr3 = [value];
      this.info.originalHouseholdPictureFirst = this.imgArr3[0].path;
    },
    delImg3() {
      this.info.originalHouseholdPictureFirst = "";
      this.imgArr3 = [];
    },
    saveImg4(value) {
      this.imgArr4 = [value];
      this.info.originalHouseholdPicture = this.imgArr4[0].path;
    },
    delImg4() {
      this.info.originalHouseholdPicture = "";
      this.imgArr4 = [];
    },
    pageChange(val) {
      this.pageNum = val;
      this.getFaceList();
    },
    async getDetail() {
      try {
        let { id: socialInsuranceId } = this.$route.query;
        console.log(socialInsuranceId);
        let res = await this.$post(this.urlobj.applyList, {
          id: socialInsuranceId,
        });
        if(!socialInsuranceId && !this.savedId) {
          // this.savedId
          this.isEdit = true;
          this.$set(this.btnList1[0], "name", "保存");
          return;
        }
        if (res.isSucceed && res.rows) {
          this.info = res.rows[0];
          this.imgArr = this.info.headPortraitPicture
            ? [{ path: this.info.headPortraitPicture }]
            : [];

          this.imgArr2 = this.info.originalCardPicture
            ? [{ path: this.info.originalCardPicture }]
            : [];

          this.imgArr3 = this.info.originalHouseholdPictureFirst
            ? [{ path: this.info.originalHouseholdPictureFirst }]
            : [];

          this.imgArr4 = this.info.originalHouseholdPicture
            ? [{ path: this.info.originalHouseholdPicture }]
            : [];

          this.comList = this.info.communityPath.split(".").map((item) => {
            return parseInt(item);
          });
          this.comList && this.comList.splice(0, 2);
          console.log(this.info);

          console.log(this.comList);
          console.log(this.communityList);

          this.isStreet = res.newPrimaryKeys.street == "no" ? true : false;
          this.isArea = res.newPrimaryKeys.area == "no" ? true : false;
          this.getFaceList();
        }
      } finally {
      }
    },
    saveInfo() {
      console.log(this.info);
      this.info.communityPath =
        "100000000000.410000000000." + this.comList.join(".");
      this.info.communityId =
        this.communityId ||
        this.info.communityPath.slice(
          this.info.communityPath.lastIndexOf(".") + 1
        );
	  
      if (!this.info.name) return this.$Message.error("请填写老人姓名");
      if (!this.info.idCardNO) return this.$Message.error("请填写老人身份证号");
      if (!this.info.phoneNO)
        return this.$Message.error("请填写老人/家属联系电话");
      if (!this.comList) return this.$Message.error("请选择所属区域");
      if (!this.info.address) return this.$Message.error("请填写老人家庭地址");
      // if (!this.info.personnelType)
      //   return this.$Message.error("请填写老人类型");
      // if (!this.info.applicantMode) return this.$Message.error("请选择申办人");
      // if (this.info.applicantMode == 2 && !this.info.agentName)
      //   return this.$Message.error("请填写代办人姓名");
      // if (this.info.applicantMode == 2 && !this.info.agentPhoneNO)
      //   return this.$Message.error("请填写代办人手机号");
      // if (this.info.applicantMode == 2 && !this.info.agentCardNO)
      //   return this.$Message.error("请填写代办人身份证");
      // if (!this.info.userName) return this.$Message.error("请填写银行户名");
      if (!this.info.bankName) return this.$Message.error("请填写银行名称");
      if (!this.info.creditCardNumbers)
        return this.$Message.error("请填写银行卡号");
      // if (!this.info.familyName) return this.$Message.error("请填写家属姓名");
      // if (!this.info.familyPhoneNO)
      //   return this.$Message.error("请填写家属联系电话");
      // if (!this.info.familyRelation)
      //   return this.$Message.error("请填写与老人关系");
	  if(this.info.idCardNO){
		  this.info.idCardNO=this.info.idCardNO.toUpperCase()
	  }
      this.btnList1[0].loading = true
      this.$post(this.urlobj.addApplyInfo, this.info)
        .then((res) => {
          this.btnList1[0].loading = false;
          this.$Message.success("提交成功");
          this.$set(this.btnList1[0], "name", "编辑");
          this.isEdit = false;
          this.savedId = res.newPrimaryKeys.id
          this.getDetail();
        })
        .catch((e) => {
          this.btnList1[0].loading = false;
          // this.$Message.error("提交失败");
        });
    },
    async getFaceList() {
      try {
        this.isLoading = true;
        let res = await this.$post(applyList, {
          idCardNO: this.info.idCardNO,
        });
        if (res.isSucceed && res.rows) {
          this.tableData = res.rows;
          this.total = res.total;
        }
        console.log(this.tableData);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.getDetail();
    this.getCommunity();
  },
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.detail {
  color: #666;
}
.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.success {
  color: #ff7b44;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}
.upload {
  margin-right: 10px;
}
.uploadbox {
  width: 100px;
  height: 100px;
  border: 1px dashed #ddd;
  color: #b5b5b5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  font-size: 14px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
  }
}
/deep/ .imgbox {
  margin: 0;
}
</style>